var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoLineClear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74322 1.18521C10.082 1.519 10.0861 2.06424 9.75229 2.40304L1.4746 10.8049C1.14081 11.1437 0.595574 11.1477 0.256777 10.8139C-0.08202 10.4802 -0.0860787 9.93492 0.247711 9.59612L8.5254 1.19428C8.85919 0.85548 9.40443 0.851421 9.74322 1.18521Z",
    fill: "#282828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.256777 1.18521C0.595574 0.851421 1.14081 0.85548 1.4746 1.19428L9.75229 9.59612C10.0861 9.93492 10.082 10.4802 9.74322 10.8139C9.40443 11.1477 8.85919 11.1437 8.5254 10.8049L0.247711 2.40304C-0.0860787 2.06424 -0.08202 1.519 0.256777 1.18521Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLineClear);
export default __webpack_public_path__ + "static/media/ico_line_clear.aad33287af87a8bf47829db77045fc05.svg";
export { ForwardRef as ReactComponent };